exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".g_tips[data-v-0ba0e426]{position:fixed;width:100%;z-index:9999;top:40%;text-align:center}.g_tips .txt[data-v-0ba0e426]{display:inline-block;margin:0 20px;min-width:100px;min-height:20px;padding:10px 20px;\n    /*! darkmode: ignore next */color:#fff;font-size:16px;line-height:30px;border-radius:8px;\n    /*! darkmode: ignore next */background-color:#000;\n    /*! darkmode: ignore next */background-color:rgba(0,0,0,.8)}", ""]);

// exports
